// Native & external imports
import {
  Component,
  OnInit,
  ElementRef,
  Renderer2,
  inject,
} from "@angular/core";
import { Router } from "@angular/router";
// Services
import { CmpAppSettings } from "src/services/cmp-app-settings.service";
import { AppRouterService } from "src//routing/routes-service";
import { LayoutService } from "src/services/layout.service";
import { LocalStorageService } from "src/services/local-storage.service";
// Objects
import { CmpFamilyMemberObject } from "src/objects/cmp-family-member.object";
import { environment } from "src/environments/environment";

@Component({
  standalone: false,
  selector: "cmp-not-found",
  templateUrl: "./not-found.component.html",
})
export class NotFoundComponent implements OnInit {
  private cmpAppSettings = inject(CmpAppSettings);
  private routerService = inject(AppRouterService);
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);
  layoutService = inject(LayoutService);
  elRef = inject(ElementRef);
  renderer = inject(Renderer2);

  public customerCareEmail = "";
  public userDetail: CmpFamilyMemberObject | null;
  public logo = "";
  public privacyPolicy: { [index: string]: string | boolean } = {};
  constructor() {
    const userLocalStorage = this.localStorageService.getItem("consumer");
    this.userDetail = userLocalStorage ? JSON.parse(userLocalStorage) : null;
  }

  ngOnInit() {
    this.getGlobalSettingsForm();
    this.loadPortalSettings();
    this.customerCareEmail = this.cmpAppSettings.getAppSetting(
      "customerServiceEmail",
    );
    if (this.layoutService.loggedIn) {
      this.layoutService.termsAndCondition.show = true;
      this.privacyPolicy.show = true;
      this.layoutService.noNavBar = false;
    } else {
      this.layoutService.noNavBar = true;
    }
  }

  /**
   * @method redirectTo
   * @description Navigate to dashboard page
   */
  public redirectTo() {
    this.router.navigate([this.routerService.componentsUrl.dashboard]);
  }

  /**
   * @method getGlobalSettingsForm
   * @description this method gets the global form settings
   */
  private getGlobalSettingsForm() {
    this.layoutService.loadPortalSettings().then((settings) => {
      this.logo = settings.logo ? settings.logo : "iCampPro";
    });
  }

  /**
   * @method loadPortalSettings
   * @description load portal settings for displaying company name
   */
  private loadPortalSettings() {
    this.layoutService.loadPortalSettings().then((settings) => {
      if (settings.buttonStyle === "pill") {
        let bodyElement: HTMLElement | null = null;
        bodyElement = this.elRef.nativeElement.ownerDocument.body;
        bodyElement = this.elRef.nativeElement.closest("body");
        this.renderer.addClass(bodyElement, "button-style-pill");
      }
      const backgroundImage = settings.background
        ? environment.s3AssetEnv + settings.background
        : `${environment.assetPrefix}/assets/images/default-background.jpg`;
      const style = this.renderer.createElement(`style`);
      const text = this.renderer.createText(
        `:root { --image-page-background: url('${backgroundImage}'); }`,
      );
      this.renderer.appendChild(style, text);
      this.renderer.setProperty(style, "type", "text/css");
      this.renderer.appendChild(
        this.elRef.nativeElement.ownerDocument.head,
        style,
      );

      // set image used in special-layout-1 container for mobile design
      const mobileStyle = this.renderer.createElement(`style`);
      const mobileText = this.renderer.createText(
        `:root { --image-sl1-top-background: url('${backgroundImage}'); }`,
      );
      this.renderer.appendChild(mobileStyle, mobileText);
      this.renderer.setProperty(mobileStyle, "type", "text/css");
      this.renderer.appendChild(
        this.elRef.nativeElement.ownerDocument.head,
        mobileStyle,
      );
      if (settings.background && settings.backgroundImageColorize === "") {
        // background-not-colorized
        this.renderer.addClass(
          this.elRef.nativeElement.querySelectorAll(".page-wrap")[0],
          "background-not-colorized",
        );
      }
    });
  }

  /**
   * @method openPrivacyPolicyPage
   * @description Redirect to view privacy policy
   */
  public openPrivacyPolicyPage() {
    if (this.privacyPolicy.choice === "text") {
      this.router.navigate([this.routerService.componentsUrl.privacyPolicy]);
    } else if (this.privacyPolicy.choice === "custom_url") {
      // open url in another page.
      window.open(String(this.privacyPolicy.value), "_blank");
    }
  }
}
